import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { TimeoutProps } from 'react-transition-group/Transition';

import styles from './Shake.module.scss';

const DEFAULT_DURATION = {
  enter: 0,
  exit: 800,
};

type ShakeProps = PropsWithChildren<{
  trigger?: number | string | boolean | null;
  duration?: TimeoutProps<HTMLElement>['timeout'];
}>;

export const Shake: FC<ShakeProps> = ({
  trigger,
  duration = DEFAULT_DURATION,
  children,
}) => {
  const [shake, setShake] = useState(false);

  useEffect(() => {
    if (trigger) {
      setShake(true);
    }

    setTimeout(() => {
      setShake(false);
    }, 0);
  }, [trigger]);

  return (
    <CSSTransition
      in={shake}
      timeout={duration}
      classNames={{ exit: styles.shake }}>
      {children}
    </CSSTransition>
  );
};
